import { siteStats } from "@/mocks/home";

export default function SiteIntro() {
  return (
    <section className="mx-auto w-full max-w-screen-xl px-4 py-12 md:px-6 md:py-16">
      <div className="grid grid-cols-1 gap-8 rounded-lg bg-primary-950 p-6 md:p-10 lg:grid-cols-2 lg:gap-12">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-800 px-3 py-1 text-xs font-medium text-accent-400">
            <span className="flex h-3 w-3 items-center justify-center">
              <i className="ri-information-line text-xs"></i>
            </span>
            关于 555电影
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl">
            你的电影资讯与选片指南
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-background-300 md:text-base">
            555电影是一个专注电影资讯与优质片单推荐的内容平台。我们持续追踪最新上映与热门影片动态，以清晰的分类、专业的评分与精心策划的专题，帮助每一位影迷用最少的时间找到最想看的电影。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-background-400">
            本站聚焦资讯整理与观影参考，不含播放、下载与会员服务。
          </p>
        </div>

        <div className="grid grid-cols-2 gap-4 md:gap-6">
          {siteStats.map((s) => (
            <div key={s.label} className="rounded-lg bg-primary-900 p-4 md:p-6">
              <p className="font-heading text-2xl font-bold text-accent-500 md:text-3xl">{s.value}</p>
              <p className="mt-2 text-xs text-background-300 md:text-sm">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}